import Vue from 'vue'
import Router from 'vue-router'

const Login = () => import('@/views/Login');
const Index = () => import('@/views/Index');
const DataReport = () => import('@/views/DataReport');
const DataManager = () => import('@/views/DataManager');
const OrderDetail = () => import('@/views/OrderDetail');
const SellSort = () => import('@/views/SellSort');
const ItemStock = () => import('@/views/ItemStock');
const Download = () => import('@/views/Download');
const Purchase = () => import('@/views/Purchase');
Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },{
      path: '/index',
      name: 'Index',
      component: Index
    },{
      path: '/dataReport',
      name: 'DataReport',
      component: DataReport
    },{
      path: '/dataManager',
      name: 'DataManager',
      component: DataManager
    },{
      path: '/orderDetail',
      name: 'OrderDetail',
      component: OrderDetail
    },{
      path: '/sellSort',
      name: 'SellSort',
      component: SellSort
    },{
      path: '/itemStock',
      name: 'ItemStock',
      component: ItemStock
    },{
      path: '/download',
      name: 'Download',
      component: Download
    },{
      path: '/purchase',
      name: 'Purchase',
      component: Purchase
    },{
      path: '*',
      redirect: '/login'
    }
  ],
  // 控制页面跳转时位置
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js